// src/firebase/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyApAP0XrqcKpbni3ziFixVCiXWKRRB9Ho0",
  authDomain: "xtrafyl-6a71e.firebaseapp.com",
  projectId: "xtrafyl-6a71e",
  storageBucket: "xtrafyl-6a71e.firebasestorage.app",
  messagingSenderId: "665618410469",
  appId: "1:665618410469:web:5d98b7afe59f12acf09d0c",
  measurementId: "G-FXGZV4P77H",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Unique device ID generate karo (persistent)
export const getDeviceId = () => {
  let deviceId = localStorage.getItem("deviceId");
  if (!deviceId) {
    deviceId = "web_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
    localStorage.setItem("deviceId", deviceId);
  }
  return deviceId;
};

// Service Worker register karo
const registerServiceWorker = async () => {
  try {
    // Always use /provider/ path since homepage is /provider
    const swPath = '/provider/firebase-messaging-sw.js';

    let registration = await navigator.serviceWorker.getRegistration('/provider/');

    if (!registration) {
      registration = await navigator.serviceWorker.register(swPath, {
        scope: '/provider/'
      });
      console.log("SW registered:", registration.scope);
    }

    return registration;
  } catch (error) {
    console.error('SW registration failed:', error);
    return null;
  }
};

// FCM Token generate karo
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    console.log("1. Permission:", permission);

    if (permission !== "granted") {
      console.log("Notification permission denied");
      return null;
    }

    const registration = await registerServiceWorker();
    console.log("2. SW Registration:", registration);

    if (!registration) {
      console.log("No SW registration");
      return null;
    }

    // Wait for SW to be active
    if (registration.active) {
      console.log("3. SW already active");
    } else {
      console.log("3. Waiting for SW to activate...");
      await new Promise((resolve) => {
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'activated') {
              resolve();
            }
          });
        });
        // If already active, resolve immediately
        if (registration.active) resolve();
      });
    }

    console.log("4. Getting FCM token...");

    const token = await getToken(messaging, {
      vapidKey: "BMKgzCk-j7aPhik7Wazm9lSX4gIyWWsgwE7mq1ItTeb2FP_GLYVfYuezDsOPK2rnfKvXJNmc79Go8RmSjF0LuVw",
      serviceWorkerRegistration: registration
    });

    console.log("5. getToken result:", token);

    if (token) {
      console.log("6. FCM Token:", token);
      localStorage.setItem("fcmToken", token);
      return token;
    }

    console.log("No token received");
    return null;
  } catch (error) {
    console.error("FCM Error:", error);
    return null;
  }
};

// Login ke baad Device Token register karo
export const registerDeviceToken = async () => {
  // Import dynamically to avoid circular dependency
  const { authAPI } = await import("../services/api");

  try {
    // Pehle FCM token lo
    const fcmToken = await requestNotificationPermission();

    if (!fcmToken) {
      console.log("No FCM token available");
      return null;
    }

    // Check if user is authenticated
    const accessToken = localStorage.getItem("token");
    if (!accessToken) {
      console.log("No access token - skipping device token registration");
      return null;
    }

    // API call karo
    const response = await authAPI.registerDeviceToken({
      DeviceId: getDeviceId(),
      FcmToken: fcmToken,
      DeviceType: "web",
      DeviceName: navigator.userAgent.substring(0, 50),
      PlatformVersion: navigator.platform || "Web",
      AppVersion: "1.0.0",
      Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });

    console.log("✅ Device token registered:", response.data);
    return fcmToken;
  } catch (error) {
    console.error("❌ Device token registration failed:", error);
    return null;
  }
};

// Logout pe device token unregister karo
export const unregisterDeviceToken = async () => {
  const { authAPI } = await import("../services/api");

  try {
    const fcmToken = localStorage.getItem("fcmToken");
    const deviceId = getDeviceId();

    if (!fcmToken && !deviceId) {
      console.log("No device info to unregister");
      return;
    }

    await authAPI.logout({
      DeviceId: deviceId,
      FcmToken: fcmToken || ""
    });

    console.log("✅ Device unregistered on logout");
    localStorage.removeItem("fcmToken");
  } catch (error) {
    console.error("❌ Device unregister failed:", error);
    // Continue with logout even if API fails
  }
};

// Foreground message listener (Promise based - one time)
export const onMessageListener = () => {
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("Foreground message:", payload);
      resolve(payload);
    });
  });
};

// Foreground message listener with callback (continuous)
export const setupForegroundNotifications = (onNotificationReceived) => {
  const unsubscribe = onMessage(messaging, (payload) => {
    console.log("📬 Foreground notification received:", payload);

    // Use data payload, fallback to notification payload
    const title = payload.data?.title || payload.notification?.title || "Xtrafyl";
    const body = payload.data?.body || payload.notification?.body || "";

    const notificationData = {
      id: payload.messageId || Date.now(),
      title: title,
      body: body,
      data: payload.data || {},
      timestamp: new Date().toISOString()
    };

    if (onNotificationReceived) {
      onNotificationReceived(notificationData);
    }

    // REMOVE browser notification - we handle it ourselves
    // if (document.hidden && Notification.permission === "granted") {
    //   showBrowserNotification(notificationData);
    // }
  });

  return unsubscribe;
};

// Browser notification show karo
const showBrowserNotification = (notificationData) => {
  const notification = new Notification(notificationData.title, {
    body: notificationData.body,
    icon: "/logo192.png",
    badge: "/logo192.png",
    tag: notificationData.data?.type || "default",
    data: notificationData.data,
    requireInteraction: true
  });

  notification.onclick = () => {
    window.focus();
    notification.close();
    const path = getNotificationNavigationPath({ Data: notificationData.data });
    if (path) {
      window.location.href = path;
    }
  };
};

// Notification click pe navigation path
export const getNotificationNavigationPath = (notification) => {
  const data = notification.Data || notification.data || {};
  const type = (data.type || data.Type || "").toUpperCase();
  const bookingId = data.booking_id || data.BookingId;
  const driverId = data.driver_id || data.DriverId;

  switch (type) {
    // Booking related
    case "NEW_BOOKING_REQUEST":
    case "NEW_BOOKING":
    case "BOOKING_ASSIGNED":
      return bookingId ? `/booking-details/${bookingId}` : "/bookings";

    case "DRIVER_ON_THE_WAY":
    case "DRIVER_ARRIVED":
    case "SERVICE_STARTED":
    case "JOB_COMPLETED":
      return bookingId ? `/booking-details/${bookingId}` : "/bookings";

    case "BOOKING_CANCELLED":
      return "/bookings";

    // Rating & Reviews
    case "CUSTOMER_RATING":
    case "NEW_REVIEW":
    case "REVIEW":
      return "/reviews";

    // Driver related
    case "DRIVER_SIGNUP_COMPLETE":
    case "DRIVER_INVITED":
    case "DRIVER_VERIFIED":
      return driverId ? `/driver-details?id=${driverId}` : "/driver";

    // Payout related
    case "PAYOUT":
    case "PAYOUT_RELEASED":
      return "/payouts";

    // Profile related
    case "PROFILE_VERIFIED":
    case "PROFILE_APPROVED":
      return "/dashboard";

    // Service related
    case "SERVICE_UPDATE":
      return "/services";

    default:
      return "/dashboard";
  }
};

export { app, messaging };
